export enum ModeType {
  Grid,
  List,
  MinifyList,
}
